import type {
  AcceptInvitationRequest,
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
  SessionUser,
  TelegramResetIssuedResponse,
} from '@robu/shared';

import { api } from '../../lib/api-client';
import { getRefreshToken } from '../../lib/token-storage';

export const authApi = {
  login: (body: LoginRequest) => api.post<LoginResponse>('/auth/login', body, { anonymous: true }),

  /** The refresh token is sent so the server can revoke this exact session. */
  logout: () => api.post<void>('/auth/logout', { refreshToken: getRefreshToken() }),

  me: () => api.get<SessionUser>('/auth/me'),

  acceptInvitation: (body: AcceptInvitationRequest) =>
    api.post<LoginResponse>('/auth/accept-invitation', body, { anonymous: true }),

  forgotPassword: (body: ForgotPasswordRequest) =>
    api.post<TelegramResetIssuedResponse>('/auth/forgot-password', body, { anonymous: true }),

  resetPassword: (body: ResetPasswordRequest) =>
    api.post<void>('/auth/reset-password', body, { anonymous: true }),

  /** Ends every session of the account, the current one included. */
  changePassword: (body: { currentPassword: string; newPassword: string }) =>
    api.post<void>('/auth/change-password', body),
};
